import { createRouter, createWebHistory } from "vue-router";
import HomePage from "@/views/HomePage.vue";
import PageNotFound from "@/components/PageNotFound";
import LoginPage from "@/views/LoginPage";
import { getCurrentUser } from '@/authService';
import store from '@/store/index.js';

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/non_resident",
  //   name: "NonResident",
  //   meta: { requiresAuth: true, noFooter: true },
  //   component: () => import("../views/NonResident.vue"),
  // },
  {
    path: "/ebook",
    name: "BukukokuPage",
    meta: { requiresAuth: true, },
    component: () => import("../views/BukukokuPage.vue"),
  },
  {
    path: "/check-payment/:id",
    name: "CheckPayament",
    meta: { requiresAuth: true, },
    component: () => import("../views/CheckPaymentPage.vue"),
  },
  {
    path: "/bookpage/:id",
    name: "BookPage",
    meta: { requiresAuth: true, },
    component: () => import("../views/BookPage.vue"),
  },
  {
    path: "/kesihatan/medical-form",
    name: "MedicalForm",
    meta: { requiresAuth: true },
    component: () => import("../views/kesihatan/MedicalForm.vue"),
  },
  {
    path: "/sponsor",
    name: "SponsorPage",
    meta: { requiresAuth: true, noFooter: true },
    component: () => import("../views/SponsorPage.vue"),
  },
  {
    path: "/vote",
    name: "VotePage",
    meta: { requiresAuth: true, noFooter: true },
    component: () => import("../views/VotePage.vue"),
  },
  {
    path: "/voting",
    name: "VotingPage",
    meta: { requiresAuth: true, noFooter: true },
    component: () => import("../views/VotingPage.vue"),
  },
  {
    path: "/sulung",
    name: "SulungPage",
    meta: { requiresAuth: true, noFooter: false },
    component: () => import("../views/SulungPage.vue"),
  },
  {
    path: "/keputusan-kolej",
    name: "ResultKolejPage",
    meta: { requiresAuth: true, noFooter: false },
    component: () => import("../views/ResultKolejPage.vue"),
  },
  {
    path: "/profile",
    name: "ProfilePage",
    meta: { requiresAuth: true },
    component: () => import("../views/ProfilePage.vue"),
  },
  {
    path: "/wifi",
    name: "WifiPage",
    meta: { requiresAuth: true },
    component: () => import("../views/WifiPage.vue"),
  },
  {
    path: "/timetable",
    name: "TimetablePage",
    meta: { requiresAuth: true },
    component: () => import("../views/TimetablePage.vue"),
  },
  {
    path: "/logout",
    name: "LogoutPage",
    meta: { requiresAuth: true },
    component: () => import("../views/LogoutPage.vue"),
  },
  {
    path: "/qr_scanner",
    name: "QrScanner",
    meta: { requiresAuth: true },
    component: () => import("../views/QrScanner.vue"),
  },
  {
    path: "/virtual_card",
    name: "VirtualCard",
    meta: { requiresAuth: true },
    component: () => import("../views/VirtualCard.vue"),
  },
  {
    path: "/transport/:id",
    name: "TransportPage",
    meta: { requiresAuth: true },
    component: () => import("../views/TransportPage.vue"),
  },
  {
    path: "/myhep/aktiviti",
    name: "AktivitiPage",
    meta: { requiresAuth: true },
    component: () => import("../views/AktivitiPage.vue"),
  },
  {
    path: "/iderms/:id",
    name: "IdermsPage",
    meta: { requiresAuth: true },
    component: () => import("../views/IdermsPage.vue"),
  },
  {
    path: "/iresidensi",
    name: "iResidensi",
    meta: { requiresAuth: true },
    component: () => import("../views/iResidensi.vue"),
  },
  /*{
    path: "/checkin/:id",
    name: "CheckinPage",
    meta: { requiresAuth: true, noFooter: true },
    component: () => import("../views/CheckinPage.vue"),
  },*/
  {
    path: "/daftar",
    name: "DaftarPage",
    meta: { requiresAuth: true, },
    component: () => import("../views/DaftarPage.vue"),
  },
  
  {
    path: "/saring",
    name: "Saring",
    meta: { requiresAuth: true },
    component: () => import("../views/SaringPage.vue"),
  },
  {
    path: "/result",
    name: "Result",
    meta: { requiresAuth: true },
    component: () => import("../views/ResultPage.vue"),
  },
  {
    path: "/vaccination",
    name: "Vaccination",
    meta: { requiresAuth: true },
    component: () => import("../views/VaccinationPage.vue"),
  },  
  {
    path: "/kad-prihatin",
    name: "KadPrihatinPage",
    meta: { requiresAuth: true, noFooter: true },
    component: () => import("../views/KadPrihatinPage.vue"),
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutPage.vue"),
  },
  {
    path: "/event/:id",
    name: "eventSingle",
    component: () => import("../views/EventSingle.vue"),
  },
  {
    path: "/login",
    name: "LoginPage",
    meta: { noHeader: true, noFooter: true, noMenu: true },
    component: LoginPage,
  },
  {
    path: "/websso/callback",
    name: "SsoPage",
    meta: { noHeader: true, noFooter: true, noMenu: true },
    component: () => import("../views/SsoPage.vue"),
  },
  {
    path: "/ikrar",
    name: "IkrarPage",
    meta: { noHeader: false, noFooter: false, noMenu: false },
    component: () => import("../views/IkrarPage.vue"),
  },
  {
    path: "/egl",
    name: "GlPage",
    meta: { noHeader: false, noFooter: false, noMenu: false },
    component: () => import("../views/kesihatan/GlPage.vue"),
  },
  {
    path: "/kesihatan",
    name: "KesehatanPage",
    meta: { noHeader: false, noFooter: false, noMenu: false },
    component: () => import("../views/kesihatan/KesehatanPage.vue"),
  },
  
  {
    path: "/:catchAll(.*)",
    name: "PageNotFound",
    component: PageNotFound,
    meta: { noHeader: true, noFooter: true, noMenu: true },
  },
  {
    path: "/masmed2u",
    name: "HomeMASMED2u",
    meta: { requiresAuth: true },
    component: () => import("../views/masmed2u/HomePageMasmed.vue"),
  },
  {
    path: "/myent",
    name: "myEnt",
    meta: { requiresAuth: true, noFooter: true },
    component: () => import("../views/masmed2u/MyEnt.vue"),
  },
  {
    path: "/tks",
    name: "TKS",
    meta: { requiresAuth: true, noFooter: true },
    component: () => import("../views/masmed2u/TKS.vue"),
  },
  {
    path: "/bill",
    name: "Bill",
    meta: { requiresAuth: true },
    component: () => import("../views/masmed2u/Bill.vue"),
  },
  {
    path: "/program/:typeProgram",
    name: "Program",
    meta: { requiresAuth: true },
    component: () => import("../views/masmed2u/Program.vue"),
  },
  {
    path: "/addProgram/:typeProgram",
    name: "AddProgram",
    meta: { requiresAuth: true },
    component: () => import("../views/masmed2u/AddProgram.vue"),
  },
  {
    path: "/admin",
    name: "AdminPage",
    meta: { requiresAuth: true },
    component: () => import("../views/AdminPage.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// const router = new Router({
//   mode: 'history',
//   linkExactActiveClass: 'active',
//   base: process.env.BASE_URL,
//   routes: routes
// })

router.afterEach(() => {
  document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
  document.body.classList.remove('modal-open');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('padding-right');
});

router.beforeEach(async (to, from, next) => {
  // Check if this is a Keycloak SSO callback (has 'state' and 'code' query params)
  // If so, allow navigation without auth check to let LoginPage process the callback
  // if (to.query.state && to.query.code) {
  //   return next();
  // }

  // Save intended destination for later redirect (except on LoginPage itself)
  // if (to.name !== 'LoginPage') {
  //   localStorage.setItem('mystudent-from', to.fullPath);
  // }

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  
  // Public routes - allow immediately
  if (!requiresAuth) {
    return next();
  }

  // Protected routes - check authentication
  try {
    const current = await getCurrentUser();
    const loggedIn = localStorage.getItem('user');

    // No Firebase user - redirect to login.
    // Reset the Vuex auth state too, not just localStorage: the store seeds
    // `loggedIn` from localStorage at boot, so if we only clear storage here the
    // store still reports loggedIn=true. LoginPage.created() then reads that
    // stale flag and pushes back to "/", which bounces here again -> infinite
    // login loop whenever the Firebase session is gone but the cached profile
    // lingered. auth/logout commits loggedIn=false and clears storage.
    if (!current) {
      store.dispatch('auth/logout');
      return next('/login');
    }

    // Firebase user exists but not in local storage - dispatch login
    if (!loggedIn) {
      try {
        const result = await store.dispatch('auth/login', current.email.split('@')[0]);
        if (result) {
          return next();
        }
        return next('/login');
      } catch (error) {
        console.error('Store login error:', error);
        return next('/login');
      }
    }

    // User is authenticated - proceed
    return next();
  } catch (e) {
    console.error('Navigation guard error:', e);
    // Same reasoning as the !current branch: reset store state so a stale
    // loggedIn flag can't bounce us back into the loop.
    store.dispatch('auth/logout');
    return next('/login');
  }
});


export default router;
